import React, { Component } from 'react'
import { Link } from 'react-router'
import {
  Paper,
  Dialog,
  MenuItem,
  TextField,
  DatePicker,
  TimePicker,
  FlatButton,
  SelectField,
  RaisedButton
} from 'material-ui'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import moment from 'moment'
import { HistoryDetails } from './HistoryDetails'
import Constants from '../../utils/CommonConstants'
import { instance } from '../../lib/api'
import { DeveloperDetails } from '../../components/Common/DeveloperDetails'
import Documents from '../../components/Documents/Documents'
import UploadDocuments from './UploadDocuments'
import DocLink from '../../components/Common/DocLink'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR
} from '../../actions/loading'

const DATE_FORMAT = 'YYYY-MM-DD'

const styleCss = {
  paperWrapper: {
    marginTop: 5,
    marginBottom: 5,
    padding: 5
  }
}
const btnStyle = {
  margin: 12
}

export default class RefundOrderDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      orderDetails: props.order,
      isReadOnly: props.reasonList.length === 0 || props.isSalesRoleOnly,
      documents: [],
      notes: ''
    }
  }

  handleCommentsChange = (event, index, value) => {
    this.setState({
      _reason: value,
      followupRequired:
        Constants.followupStatus.indexOf(value.nextStatusId) !== -1
          ? Constants.configMsgs.required
          : null
    })
  }

  handleRefundDetailsChange = (key, value) => {
    let { orderDetails } = this.state
    orderDetails.refundDetails[key] = value
    this.setState({
      orderDetails
    })
  }

  handleRcmOrderDetailsChange = (key, value) => {
    let { orderDetails } = this.state
    orderDetails.rcmOrder[key] = value
    this.setState({
      orderDetails
    })
  }

  handleRefundDateChange = (key, date) => {
    let { orderDetails } = this.state
    orderDetails.refundDetails[key] = moment(date).format(DATE_FORMAT)
    this.setState({
      orderDetails
    })
  }

  handleFollowupDate = (event, date) => {
    this.setState({
      followUpDate: date
    })
  }

  handleFollowupTime = (event, date) => {
    this.setState({
      followUpTime: date
    })
  }

  handleCommentNotesChange = (key, value) => {
    this.setState({
      notes: value
    })
  }

  toggelUploadDocuments = () => {
    this.setState({
      isUploadDocuments: !this.state.isUploadDocuments
    })
    if (this.docsUploaded) {
      this.docsUploaded = false
      this.showDocuments()
    }
  }

  handleModalClose = () => {
    this.setState({
      showModal: '',
      isUploadDocuments: false
    })
  }

  showModal = modal => {
    this.setState({
      showModal: modal
    })
  }

  openDeveloperModal = () => {
    this.showModal('developer')
  }

  openDocumentsModal = () => {
    this.showModal('documents')
  }

  componentWillReceiveProps(nextProps) {
    let orderId = this.props.order.rcmOrder.id
    let { accountId, accountLegalEntityId } = this.props.order.refundDetails
    if (nextProps.documents[orderId] && !this.props.documents[orderId]) {
      this.setState(
        {
          documents: nextProps.documents[orderId]
        },
        this.openDocumentsModal
      )
    }
    if (
      nextProps.developerDetails !== this.props.developerDetails &&
      nextProps.developerDetails[accountId]
    ) {
      const legalEntities = nextProps.developerDetails[accountId]
      this.setState(
        {
          developer: this.getLegalEntity(legalEntities, accountLegalEntityId)
        },
        this.openDeveloperModal
      )
    }
    if (nextProps.reasonList !== this.props.reasonList) {
      this.setState({
        isReadOnly:
          nextProps.reasonList.length === 0 || nextProps.isSalesRoleOnly
      })
    }
  }

  getLegalEntity = (entityList, entityId) => {
    const entity =
      (entityList.length && entityList.find(le => entityId === le.id)) || {}
    return { ...entity, name: entity.legalName }
  }

  showDeveloperDetails = () => {
    let { accountId, accountLegalEntityId } = this.props.order.refundDetails
    const { getDeveloperDetails } = this.props
    if (this.props.developerDetails[accountId]) {
      this.setState(
        {
          developer: this.getLegalEntity(
            this.props.developerDetails[accountId],
            accountLegalEntityId
          )
        },
        this.openDeveloperModal
      )
    } else {
      getDeveloperDetails(accountId)
    }
  }

  showDocuments = () => {
    let { id, paymentsId, caseSubTypeId } = this.props.order.rcmOrder
    const { dispatch, getOrderDocuments } = this.props
    if (this.props.documents[id]) {
      this.setState(
        {
          documents: this.props.documents[id]
        },
        this.openDocumentsModal
      )
    } else {
      getOrderDocuments(id, paymentsId, 'Payment', caseSubTypeId)
    }
  }

  uploadDocumentsSuccess = () => {
    let { id } = this.props.order.rcmOrder
    this.props.deleteOrderDocuments(id)
    this.docsUploaded = true
  }

  getInvoiceUrl = media => {
    let mediaWithMaxId = null
    if (media && media.length) {
      media.forEach(m => {
        if (!mediaWithMaxId || m.id > mediaWithMaxId.id) {
          mediaWithMaxId = m
        }
      })
    }
    return mediaWithMaxId
  }

  getInvoiceDetails = invoiceList => {
    let result = [],
      { isRcmAdmin } = this.props
    let taxInvoiceWithMaxId, digislateInvoiceWithMaxId
    if (invoiceList && invoiceList.length) {
      if (isRcmAdmin) {
        result = invoiceList
      } else {
        invoiceList.forEach(invoice => {
          if (invoice.type === 'Tax') {
            if (
              invoice.otherAmount !== null &&
              (!taxInvoiceWithMaxId || invoice.id > taxInvoiceWithMaxId.id)
            ) {
              taxInvoiceWithMaxId = invoice
            } else if (
              invoice.digislateAmount !== null &&
              (!digislateInvoiceWithMaxId ||
                invoice.id > digislateInvoiceWithMaxId.id)
            ) {
              digislateInvoiceWithMaxId = invoice
            }
          }
        })
        if (taxInvoiceWithMaxId) {
          //taxInvoiceWithMaxId.invoiceType = 'Tax Invoice';
          result.push(taxInvoiceWithMaxId)
        }
        if (digislateInvoiceWithMaxId) {
          //digislateInvoiceWithMaxId.invoiceType = 'Digislate Invoice';
          result.push(digislateInvoiceWithMaxId)
        }
      }
    }
    return result
  }

  submit = () => {
    if (!this.state.orderDetails.rcmOrder.agentId) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'This Order is Unassigned'
      })
      return
    }
    const reasonID = this.state._reason ? this.state._reason.id : null
    const refundDetails = this.state.orderDetails.refundDetails
    const rcmOrder = this.state.orderDetails.rcmOrder
    const putData = {
      rcmOrder,
      refundDetails
    }
    if (!reasonID) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Please select a reason.'
      })
      return
    } else if (
      Constants.handoverDateMandatoryReasons.indexOf(reasonID) !== -1 &&
      !this.state.orderDetails.refundDetails.rcmHandoverDate
    ) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'RCM Handover Date is mandatory.'
      })
      return
    }

    const followuptime = moment(this.state.followUpDate)
    if (this.state.followUpDate && this.state.followUpTime) {
      const time = moment(this.state.followUpTime)
      followuptime.set({ hour: time.get('hour'), minute: time.get('minute') })
    } else if (
      Constants.followupStatus.indexOf(this.state._reason.nextStatusId) !== -1
    ) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Please select followup Date and Time.'
      })
      return
    }
    putData.rcmOrder.fupTime = this.state.followUpDate
      ? followuptime.valueOf()
      : null
    putData.reasonId = reasonID || null
    putData.notes = this.state.notes
    const url = Constants.configUrls.REFUND_PUT()
    this.props.putHandler(putData, url)
  }

  render() {
    const { orderDetails, notes, isUploadDocuments, isReadOnly } = this.state
    const { refundDetails, rcmOrder } = orderDetails
    const { paymentStatusMap } = this.props
    const invoiceDetails = this.getInvoiceDetails(refundDetails.invoiceDetails)
    let orderType
    switch (rcmOrder.caseSubTypeId) {
      case Constants.CaseSubTypeMap.BROKER.REFUND:
      case Constants.CaseSubTypeMap.DEVELOPER.REFUND:
      case Constants.CaseSubTypeMap.MAKAAN.REFUND:
      case Constants.CaseSubTypeMap.OWNER.REFUND:
        orderType = true
        break
      default:
        orderType = false
    }
    const creditNote =
      refundDetails.creditNoteDetails &&
      refundDetails.creditNoteDetails.length &&
      refundDetails.creditNoteDetails.map(note => (
        <DocLink key={note.mediaLink} url={note.mediaLink} />
      ))
    return (
      <div>
        <section className='order-rcm-info clearfix'>
          {orderType && (
            <div className='col-xs-12 ta-c'>
              <h2>Refunds</h2>
            </div>
          )}
          <div className='col-xs-6 col-md-3'>
            <p className='lg-info'>
              <strong>Refund ID: </strong>
              {refundDetails ? refundDetails.id : '----------'}
            </p>
            <p className='sm-info'>
              ({this.props.caseStatusMap[rcmOrder.statusId]})
            </p>
            {rcmOrder.sourcePaymentCase && (
              <p className='sm-info'>
                <label>Source Payment Id: </label>
                <Link
                  to={`/detail/${rcmOrder.sourcePaymentCase}`}
                  target='_blank'
                >
                  {refundDetails.paymentId}
                </Link>
              </p>
            )}
          </div>
          <div className='col-xs-6'>
            <p className='lg-info'>
              {refundDetails.ramUser
                ? refundDetails.ramUser.fullName
                : '----------'}
            </p>
          </div>
          <div className='col-xs-6 col-md-3'>
            <p className='lg-info'>
              {refundDetails.ramUser &&
              refundDetails.ramUser.contactNumbers.length
                ? refundDetails.ramUser.contactNumbers[0].contactNumber
                : '----------'}
            </p>
            <p className='sm-info'>
              {orderDetails.cityName ? orderDetails.cityName : '----------'}
            </p>
          </div>
        </section>
        <div className='container-fluid' style={{ paddingBottom: '60px' }}>
          <Paper zDepth={1} style={styleCss.paperWrapper}>
            <div className='container-fluid'>
              <div className='row box-wrap'>
                <p>
                  Opportunity Details{' '}
                  <span className='static-field pull-right'>
                    <label>Term Sheet Number: </label>{' '}
                    <Link
                      to={`/detail/${rcmOrder.termsheetCaseId}`}
                      target='_blank'
                    >
                      {refundDetails.termsheetNumber}
                    </Link>
                  </span>
                </p>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Opportunity Id'
                    floatingLabelText='Opportunity Id'
                    disabled
                    type='number'
                    value={refundDetails.opportunityId || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Opportunity Name'
                    floatingLabelText='Opportunity Name'
                    disabled
                    value={refundDetails.opportunityName || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Deal Amount'
                    floatingLabelText='Deal Amount'
                    disabled
                    value={refundDetails.opportunityDetails.dealValue || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Termsheet Number'
                    floatingLabelText='Termsheet Number'
                    disabled
                    value={refundDetails.termsheetNumber || ''}
                  />
                </div>
              </div>
              <div className='row box-wrap'>
                <p>Refund Details</p>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Milestone Id'
                    floatingLabelText='Milestone Id'
                    disabled
                    value={refundDetails.milestoneId || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Payment Mode'
                    floatingLabelText='Payment Mode'
                    disabled
                    value={paymentStatusMap[refundDetails.paymentModeId] || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Amount'
                    floatingLabelText='Amount'
                    type='number'
                    disabled={isReadOnly}
                    value={refundDetails.amount || ''}
                    onChange={(event, value) =>
                      this.handleRefundDetailsChange('amount', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Handover To'
                    floatingLabelText='Handover To'
                    disabled={isReadOnly}
                    value={rcmOrder.handoverTo}
                    onChange={(event, value) =>
                      this.handleRcmOrderDetailsChange('handoverTo', value)
                    }
                  />
                </div>
              </div>
              {invoiceDetails.length > 0 && (
                <div className='row box-wrap'>
                  <p>Invoice Details</p>
                  <Table onRowSelection={this.handleRowSelection}>
                    <TableHeader
                      displaySelectAll={false}
                      adjustForCheckbox={false}
                    >
                      <TableRow>
                        <TableHeaderColumn>Invoice Number</TableHeaderColumn>
                        <TableHeaderColumn>Date</TableHeaderColumn>
                        <TableHeaderColumn>Amount</TableHeaderColumn>
                        <TableHeaderColumn>Type</TableHeaderColumn>
                        <TableHeaderColumn>Invoice Link</TableHeaderColumn>
                        <TableHeaderColumn>Action</TableHeaderColumn>
                      </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                      {Array.isArray(invoiceDetails)
                        ? [...invoiceDetails]
                            .sort((a, b) => a.id - b.id)
                            .map((invoice, index) => {
                              const mediaWithMaxId = this.getInvoiceUrl(
                                invoice.media
                              )
                              return (
                                <TableRow key={index}>
                                  <TableRowColumn>
                                    {invoice.invoiceNumber}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {moment(invoice.createdAt).format(
                                      Constants.DATE_FORMAT
                                    )}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {invoice.otherAmount ||
                                      invoice.digislateAmount}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {invoice.type === 'Tax'
                                      ? 'Tax Invoice'
                                      : 'Digislate Invoice'}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {mediaWithMaxId && (
                                      <DocLink
                                        url={mediaWithMaxId.absoluteUrl}
                                      />
                                    )}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {mediaWithMaxId && (
                                      <React.Fragment>
                                        <FlatButton
                                          className='sm-info'
                                          label='Regenerate'
                                          disabled={isReadOnly}
                                          primary={true}
                                          onClick={() =>
                                            this.props.deleteOrderInvoice(
                                              invoice.id,
                                              true
                                            )
                                          }
                                        />
                                        <FlatButton
                                          className='sm-info'
                                          label='Cancel'
                                          disabled={isReadOnly}
                                          primary={true}
                                          onClick={() =>
                                            this.props.deleteOrderInvoice(
                                              invoice.id,
                                              false
                                            )
                                          }
                                        />
                                      </React.Fragment>
                                    )}
                                  </TableRowColumn>
                                </TableRow>
                              )
                            })
                        : null}
                    </TableBody>
                  </Table>
                </div>
              )}
              {creditNote && (
                <p>
                  <label>Credit Note:</label> {creditNote}
                </p>
              )}
              <div className='row box-wrap box-grey'>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Comment</label>
                  </div>
                  <div className='col-md-9 col-xs-8'>
                    <SelectField
                      value={this.state._reason}
                      disabled={isReadOnly}
                      onChange={this.handleCommentsChange}
                      hintText={'Select Comment'}
                      fullWidth
                    >
                      {this.props.reasonList.map(reason => {
                        return (
                          <MenuItem
                            value={reason}
                            key={reason.id}
                            primaryText={reason.label}
                          />
                        )
                      })}
                    </SelectField>
                  </div>
                </div>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Followup Date</label>
                  </div>
                  <div className='row col-md-9 col-xs-8'>
                    <div className='col-xs-6 col-md-4'>
                      <DatePicker
                        hintText='Followup Date'
                        value={this.state.followUpDate}
                        minDate={moment().toDate()}
                        disabled={isReadOnly}
                        onChange={this.handleFollowupDate}
                        errorText={
                          this.state.followUpDate
                            ? null
                            : this.state.followupRequired
                        }
                      />
                    </div>
                    <div className='col-xs-6 col-md-4'>
                      <TimePicker
                        format='ampm'
                        minutesStep={5}
                        hintText='Followup Time'
                        disabled={isReadOnly}
                        errorText={
                          this.state.followUpTime
                            ? null
                            : this.state.followupRequired
                        }
                        onChange={this.handleFollowupTime}
                        value={this.state.followUpTime}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Notes</label>
                  </div>
                  <div className='col-md-9 col-xs-8'>
                    <TextField
                      hintText='Notes'
                      disabled={isReadOnly}
                      value={notes}
                      onChange={this.handleCommentNotesChange}
                      fullWidth
                    />
                  </div>
                </div>
                <div className='col-xs-12 text-center'>
                  <RaisedButton
                    label='Submit'
                    primary
                    disabled={isReadOnly}
                    style={btnStyle}
                    onClick={this.submit}
                  />
                </div>
              </div>
              <section className='footer-fixed-actions'>
                <div
                  className='footer-action-item'
                  onClick={this.showDeveloperDetails}
                >
                  Developer Details
                </div>
                <div
                  className='footer-action-item'
                  onClick={this.showDocuments}
                >
                  Documents
                </div>
                <div
                  className='footer-action-item'
                  onClick={() => this.showModal('history')}
                >
                  History
                </div>
              </section>
            </div>
          </Paper>
          <Dialog
            title='Developer Details'
            actions={
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            }
            modal={false}
            open={this.state.showModal === 'developer'}
            onRequestClose={this.handleModalClose}
          >
            {this.state.developer ? (
              <DeveloperDetails details={this.state.developer} />
            ) : (
              <p>Developer Details not available.</p>
            )}
          </Dialog>
          <Dialog
            title='Documents Details'
            actions={[
              <FlatButton
                label={isUploadDocuments ? 'Done Upload' : 'Upload Documents'}
                primary
                disabled={isReadOnly}
                onClick={this.toggelUploadDocuments}
              />,
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            ]}
            modal={false}
            open={this.state.showModal === 'documents'}
            autoScrollBodyContent
            onRequestClose={this.handleModalClose}
          >
            {isUploadDocuments ? (
              <UploadDocuments
                orderType={rcmOrder.caseSubTypeId}
                orderId={rcmOrder.paymentsId}
                onUploadSuccess={this.uploadDocumentsSuccess}
                objectType={'Payment'}
                docTypes={Constants.documentTypes.PAYMENTS}
                dispatch={this.props.dispatch}
              />
            ) : this.state.documents &&
              Object.keys(this.state.documents).length ? (
              <Documents documents={this.state.documents} />
            ) : (
              <p>Documents Details not available.</p>
            )}
          </Dialog>

          <Dialog
            title='History Details'
            autoScrollBodyContent
            actions={
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            }
            modal={false}
            open={this.state.showModal === 'history'}
            onRequestClose={this.handleModalClose}
          >
            {rcmOrder.actions && rcmOrder.actions.length ? (
              <HistoryDetails
                caseActions={rcmOrder.actions}
                caseStatusMap={this.props.caseStatusMap}
              />
            ) : (
              <p>History Details not available.</p>
            )}
          </Dialog>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/OrderDetails/RefundOrderDetails.js
 **/